import { COOKIE_SAVINGS_ACCOUNT_SEARCH } from '@/constants/cookies';
import { getSavingsAccounts, getSavingsAccountSearch } from '@/graphql/queries/banking/savings-account';
import lang from '@/lang/middleware/products/banking/savings-accounts';

export default async ({ $api, $apolloQuery, $cookies, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const code = $cookies.get(COOKIE_SAVINGS_ACCOUNT_SEARCH);
  const defaultSearch = () => store.commit('search/reset', { type: 'saving' });
  const title = store.$i18n.t('your-results.title');
  store.commit('pageContent/setHead', { title });
  await $api('banking/savingsearches').then(r => store.commit('products/setValidations', r));
  if (!code) {
    return defaultSearch();
  };
  await $apolloQuery(getSavingsAccountSearch, { code }).then(search => store.commit('search/set', search)).catch(defaultSearch);
  await $apolloQuery(getSavingsAccounts).then(accounts => {
    store.commit('products/setList', accounts);
    store.commit('providers/setListFromProducts', accounts);
  });
};
